module.exports = __webpack_public_path__ + "media/images/dog_bg-70425318852e71d3bbf7b14dd7e2ed0e.jpg";